import Button from "elements/Button";

import ImageHero from "assets/images/hero-image.png";

export default function Hero() {
  const scrollToProduct = () => {
    const productSection = document.getElementById("productSection");
    if (productSection) {
      productSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <section className="section-hero">
        <div className="container">
          <div className="row">
            <div className="col-6 content">
              <h1 className="">
                Be Trendy And <br />
                In Style
              </h1>
              <h6 className="my-3">
                Explore the latest shoes for every sport, <br /> workout and
                everyday look. Built for <br /> ultimate performance and sneaker
                style.
              </h6>
              <Button className="btn" isPrimary onClick={scrollToProduct}>
                Show Me Now
              </Button>
            </div>
            <div className="col-6">
              <img className="img-fluid" src={ImageHero} alt="" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
